import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styles from "./Thanks.module.scss";
import { reset_state } from '../../features/business/businessSlice';
import ProtectedPaymentRoute from '../auth/Auth';

export default function Thank() {
  ProtectedPaymentRoute();

  const business = useSelector((state) => state.business);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(false);

  const businessName = business?.businessDetails?.businessName || "your business";

  useEffect(() => {
    // Trigger animation on mount
    const t = setTimeout(() => setVisible(true), 80);
    return () => clearTimeout(t);
  }, []);

  const handleHome = () => {
    localStorage.clear();
    dispatch(reset_state());
    navigate("/");
  };

  return (
    <div className={styles.page}>
      <section className={`${styles.confirm} ${visible ? styles.visible : ""}`}>

        {/* Animated checkmark */}
        <div className={styles.iconRing}>
          <div className={styles.iconCircle}>
            <svg
              className={styles.checkSvg}
              viewBox="0 0 52 52"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle className={styles.checkCircle} cx="26" cy="26" r="25" />
              <path
                className={styles.checkMark}
                d="M14.5 26.5l8 8 15-16"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>

        {/* Content */}
        <div className={styles.content}>
          <h1 className={styles.title}>Payment successful!</h1>
          <p className={styles.subtitle}>
            Your request to register{" "}
            <strong>{businessName}</strong>{" "}
            has been received. We'll get in touch with you shortly.
          </p>

          {/* What happens next */}
          <div className={styles.stepsRow}>
            <div className={styles.step}>
              <div className={styles.stepIcon}>
                <i className="fa-solid fa-envelope"></i>
              </div>
              <p className={styles.stepText}>Confirmation email sent</p>
            </div>
            <div className={styles.stepDivider}></div>
            <div className={styles.step}>
              <div className={styles.stepIcon}>
                <i className="fa-solid fa-file-lines"></i>
              </div>
              <p className={styles.stepText}>Documents prepared</p>
            </div>
            <div className={styles.stepDivider}></div>
            <div className={styles.step}>
              <div className={styles.stepIcon}>
                <i className="fa-solid fa-building"></i>
              </div>
              <p className={styles.stepText}>Business registered</p>
            </div>
          </div>

          <button id="back-to-home-btn" className={styles.homeBtn} onClick={handleHome}>
            Back to home
          </button>

          <p className={styles.note}>
            <i className="fa-solid fa-lock"></i>{" "}
            Your information is secured with 256-bit SSL encryption.
          </p>
        </div>

      </section>
    </div>
  );
}
